import { PayloadAction } from "@reduxjs/toolkit";
import { updateItemInCollection } from "./update-item-in-collection";
import { IActivityHistoryItem } from "../domain/model";

export function updateActivityHistoryItemReducer(
  state,
  action: PayloadAction<{ id: string; item: IActivityHistoryItem }>,
) {
  const { id, item } = action.payload;
  state.collections = updateItemInCollection(state.collections, id, item);
}
